<h2 mat-dialog-title>
    {{ (isEdit ? 'permit.config.form_builder.dialog_title_edit' : 'permit.config.form_builder.dialog_title_create') | translate }}
</h2>
<mat-dialog-content [formGroup]="form">
    <div class="field-group">
        <label class="field-label">{{ 'permit.config.form_builder.label_fr' | translate }}</label>
        <input class="field-input" formControlName="labelFr" />
        <div class="field-error" *ngIf="form.get('labelFr').touched && form.get('labelFr').invalid">
            {{ 'permit.config.common.required_error' | translate }}
        </div>
    </div>
    <div class="field-group">
        <label class="field-label">{{ 'permit.config.form_builder.label_en' | translate }}</label>
        <input class="field-input" formControlName="labelEn" />
        <div class="field-error" *ngIf="form.get('labelEn').touched && form.get('labelEn').invalid">
            {{ 'permit.config.common.required_error' | translate }}
        </div>
    </div>
    <div class="field-group">
        <label class="field-label">{{ 'permit.config.form_builder.field_type' | translate }}</label>
        <select class="field-input" formControlName="type">
            <option *ngFor="let type of fieldTypes" [value]="type">
                {{ 'permit.config.form_builder.type_' + type | translate }}
            </option>
        </select>
    </div>
    <div class="field-group">
        <app-form-toggle formControlName="required">
            {{ 'permit.config.form_builder.required' | translate }}
        </app-form-toggle>
    </div>

    <div class="field-group" *ngIf="selectedType === 'dropdown'">
        <label class="field-label">{{ 'permit.config.form_builder.options' | translate }}</label>
        <div class="option-row" *ngFor="let option of options; let i = index">
            <span class="option-text">{{ option }}</span>
            <button type="button" mat-icon-button (click)="removeOption(i)">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="option-add">
            <input
                class="field-input"
                [(ngModel)]="newOption"
                [ngModelOptions]="{ standalone: true }"
                [placeholder]="'permit.config.form_builder.option_placeholder' | translate"
                (keydown.enter)="addOption(); $event.preventDefault()"
            />
            <button type="button" mat-stroked-button (click)="addOption()">
                {{ 'permit.config.common.add' | translate }}
            </button>
        </div>
        <div class="field-error" *ngIf="optionsError">
            {{ 'permit.config.form_builder.options_error' | translate }}
        </div>
    </div>

    <div class="field-row" *ngIf="selectedType === 'number' || selectedType === 'date'">
        <div class="field-group">
            <label class="field-label">{{ 'permit.config.form_builder.min' | translate }}</label>
            <input class="field-input" type="number" formControlName="min" [attr.min]="selectedType === 'number' ? 0 : null" />
        </div>
        <div class="field-group">
            <label class="field-label">{{ 'permit.config.form_builder.max' | translate }}</label>
            <input class="field-input" type="number" formControlName="max" [attr.min]="selectedType === 'number' ? 0 : null" />
        </div>
    </div>

    <div class="field-group" *ngIf="selectedType === 'url'">
        <label class="field-label">{{ 'permit.config.form_builder.preset_value' | translate }}</label>
        <input class="field-input" formControlName="presetValue" placeholder="https://" (input)="presetValueError = false" />
        <div class="field-error" *ngIf="presetValueError">
            {{ 'permit.config.form_builder.preset_value_error' | translate }}
        </div>
    </div>

    <div class="field-group">
        <label class="field-label">{{ 'permit.config.form_builder.section' | translate }}</label>
        <input class="field-input" formControlName="section" />
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">{{ 'permit.config.common.cancel' | translate }}</button>
    <button mat-flat-button color="primary" type="button" (click)="save()">
        {{ 'permit.config.common.save' | translate }}
    </button>
</mat-dialog-actions>
